import storeLocator from 'modules/storeLocator';
import listMapSwitch from 'modules/listMapSwitch';

export default {
	init() {
		storeLocator.init($('#store-locator-search'), $('#store-locator-filters'), $('#store-locator-map'));
		listMapSwitch.init($('.js-store-switch'), $('.js-store-tab'));
	},
};